export const environment = {
  production: false,
  apiBaseAddress: "https://vitahomolog.workfinity.api.br/api/",

  envName: "qa",
  version: "1.0.1",

  hereApiKey: "KveI3PiZekt1av1z4UUj60CARM5E7CBNepJLv4RUZo0",
};

export const custom = {
  logo_login: null,
};
